import PropTypes from "prop-types";
import React from "react";

import { Graphic } from "../Graphic";
import { Transition, transitionPropTypes } from "../Transition";
import { pictograms } from "./pictograms";

/**
 * Pictogram renders a predefined illustration as defined by the illustrations defined in pictogram.js.
 *
 */
export const Pictogram = (props) => {
  const { animate, className, initial, name, style, transition } = props;
  const pictogram = pictograms[name];
  const { graphics } = pictogram;

  return <Transition {...getProps()}>{graphics.map(renderGraphic)}</Transition>;

  function renderGraphic(graphic, index) {
    return <Graphic key={index} {...getGraphicProps(graphic)} />;
  }

  function getProps() {
    return {
      animate: { ...pictogram.animate, ...animate },
      className,
      initial: { ...pictogram.initial, ...initial },
      style: { ...pictogram.style, ...style },
      transition: { ...pictogram.transition, ...transition },
    };
  }

  function getGraphicProps(graphic) {
    const { name: graphicName, svgProps, svgElementProps } = graphic;

    return {
      animate: { ...svgProps?.animate },
      initial: { ...svgProps },
      name: graphicName,
      style: { ...svgProps?.style },
      svgElementProps: { ...svgElementProps },
      transition: { ...svgProps?.transition },
    };
  }
};

Pictogram.displayName = "Pictogram";

Pictogram.propTypes = {
  /** Values to transition. See Transition component for more information. */
  animate: transitionPropTypes.animate,

  /** Additional classes for positioning the component. */
  className: PropTypes.string,

  /** Values to transition. See Transition component for more information. */
  initial: transitionPropTypes.initial,

  /** Name of pictogram defined in pictogram.js. */
  name: PropTypes.string.isRequired,

  /** This object provides a way to add CSS values in addition to the properties that will be transformed. */
  style: PropTypes.object,

  /** Values to transition. See Transition component for more information. */
  transition: transitionPropTypes.transition,
};
